import {ProcessadorTexto} from './ProcessadorTexto';

export class ProcessadorSangriaTexto extends ProcessadorTexto {
  private formateData(valor: any) {
    if(!valor)
      return '-';

    const data = new Date(valor);

    if(isNaN(data.getTime()))
      return '-';

    return data.toLocaleString('pt-BR').split(',').join('');
  }

  private linhasDoTexto(texto: string) {
    return this.multiplasLinhas(String(texto || '-'), this.papel.tamanhoLinha, false)
      .map((linha: string) => this.linha(linha.trim()))
      .join('');
  }

  obtenhaComprovanteSangria(sangria: any) {
    const empresa = sangria?.empresa?.nome || sangria?.caixa?.empresa?.nome || '-';
    const operador = sangria?.operador?.nome || '-';
    const horaImpressao = sangria?.horaImpressao || new Date();
    const valor = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(Number(sangria?.valorRetirado) || 0);

    let comprovante = this.centralizarLinha(empresa);
    comprovante += this.centralizarLinha('COMPROVANTE DE SANGRIA');
    comprovante += this.linhaComCaracter('-');
    comprovante += this.linha(`Sangria: #${sangria?.id || '-'}`);
    comprovante += this.linha(`Caixa: #${sangria?.caixa?.id || '-'}`);
    comprovante += this.linhasDoTexto(`Operador: ${operador}`);
    comprovante += this.linhasDoTexto(`Abertura do caixa: ${this.formateData(sangria?.caixa?.horarioAbertura)}`);
    comprovante += this.linhasDoTexto(`Realizada em: ${this.formateData(sangria?.dataHoraRealizada)}`);
    comprovante += this.linhasDoTexto(`Impresso em: ${this.formateData(horaImpressao)}`);
    comprovante += this.linhaComCaracter('-');
    comprovante += this.centralizarLinha('VALOR RETIRADO');
    comprovante += this.centralizarLinha(valor);
    comprovante += this.linhaComCaracter('-');
    comprovante += this.linha('Justificativa:');
    comprovante += this.linhasDoTexto(sangria?.justificativa);
    comprovante += this.linha();
    comprovante += this.linhasDoTexto('Declaro o recebimento do valor indicado neste comprovante.');
    comprovante += this.linha();
    comprovante += this.linha();
    comprovante += this.linhaComCaracter('_');
    comprovante += this.centralizarLinha('Assinatura do responsável');
    comprovante += this.linha();

    return comprovante;
  }
}
